module.exports = __webpack_public_path__ + "img/initial-balance.99e18e5e.png";